import {
  CreateContextProvider,
  Form,
  SaveButton,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../../resource';
import LinkConfigForm from './LinkConfigForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateLinkConfig = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.linkConfig,
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.linkConfig.createSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        if (errorCode === 'LINK_CONFIG_CONFLICT') {
          notify(t('module.linkConfig.validate.conflict'), { type: 'error' });
        } else {
          notify(t('module.linkConfig.unknownError'), { type: 'error' });
        }
      },
    },
  });

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.linkConfig.create')}</DialogTitle>
        <DialogContent>
          <LinkConfigForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="link-configs" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateLinkConfig;
